/**
 * Valuations Entity Configuration
 * TODO: Implement in subtask 14.3
 */

import { useValuations, useValuation } from "../../../hooks/useApi";

const ValuationsConfig = {
  entity: "valuations",
  entitySingular: "Valuation",
  entityPlural: "Valuations",

  hooks: {
    useEntities: useValuations,
    useEntity: useValuation,
  },

  routes: {
    list: "/valuations",
    detail: "/valuation/:id",
    new: "/new-valuation",
    edit: "/valuation/:id/edit",
  },

  statusOptions: [
    { value: "draft", label: "Draft", color: "gray" },
    { value: "active", label: "Active", color: "green" },
    { value: "completed", label: "Completed", color: "blue" },
    { value: "cancelled", label: "Cancelled", color: "red" },
  ],

  filterFields: ["status", "valuation_type"],
  searchFields: ["property_address", "description"],

  primaryField: "property_address",
  secondaryField: "description",

  defaultLayout: "cards",

  emptyState: {
    title: "No valuations found",
    description: "Start by creating your first valuation",
    actionText: "Create New Valuation",
    actionRoute: "/new-valuation",
  },

  features: {
    hasCategories: true,
    hasStatusBadges: true,
    hasProgressIndicators: true,
    hasQuickActions: true,
    supportsBulkActions: false,
  },
};

export default ValuationsConfig;
